// extracted by css-extract-rspack-plugin
export default {"adminDashboard":"M1NILskndPI5MpUO","main":"amzESW81_I58JGEk","side":"zxh6n4UiEIu4sTTW"};